import service, { serviceGo } from "@/utils/request";

export interface Game {
  id: number
  title: string
  description: string
  url: string
  model_id: number
  model: string
  channel: string
  display: string
  nodeVersion?: string // 缓存的节点版本信息
  tags?: string // JSON string of tags array
  category?: string[] // 分类数组（如：["仙侠", "言情"]）
  serial_status?: number // 0: 连载中, 1: 完结
  boutique_tag?: string // 首页角标标签文案（admin 填写，最多6字，空则不展示）
  content_channel?: string // 内容频道: 男频/女频
  heat?: number // 热度值
  heat_boost?: number // 热度加成（手动设置）
  price_per_thousand_words?: number // 千字单价（元），默认80
  pen_name?: string // 书级笔名（对外展示署名，空则展示作者用户名）
  default_player_name?: string // 默认主控名（未命名时显示，{姓名}占位兜底）
}

export interface Model{
  id:number
  model:string
  channel:string
  model_desc?:string
  param_model: string
}


// 获取全部游戏（不分页），用于下拉选择器等
export async function getGames(): Promise<Game[]> {
  const response = await service.get<Game[]>('/api/games/backend', { params: { page_size: -1 } })
  return response.data
}

// 「新流程」小说的起始 id。AI剧情生成、属性调整这类新功能只对 id ≥ 此值的书开放。
// 这是产品侧划的线、不是技术限制；要放开改这一个数即可，改了所有用到的页面一起变。
export const MIN_GAME_ID = 57

// 只返回走新流程的小说。别在各页面各写一遍 filter —— 那样口径迟早分叉。
export async function getRecentGames(): Promise<Game[]> {
  return (await getGames()).filter(g => g.id >= MIN_GAME_ID)
}

// 分页获取游戏列表
export interface PagedGamesResult {
  data: Game[]
  total: number
  page: number
  page_size: number
}

export async function getGamesPaged(page: number, pageSize: number, search?: string): Promise<PagedGamesResult> {
  const params: Record<string, unknown> = { page, page_size: pageSize }
  if (search) params.search = search
  const response = await service.get<PagedGamesResult>('/api/games/backend', { params })
  return response.data
}

export async function saveGame(id: number, data: Game): Promise<void>{
  await service.put<Game[]>(`/api/games/${id}`, data)
}


export async function getModels(): Promise<{data: Model[], message: string}>{
  const response = await service.get<{data: Model[], message: string}>('/api/games/models')
  return response.data
}

export interface CreateGameRequest {
  title: string
  description?: string
  category?: string[]
  tags?: string[]
  content_channel?: string
}

export async function createGame(data: CreateGameRequest): Promise<Game> {
  const resp = await serviceGo.post('/api_v2/games/create', data)
  return resp.data.data
}